import { useEffect, useMemo, useState } from "react";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { Paginator } from "primereact/paginator";
import SearchBar from "../common/SearchBar";
import Loading from "../common/Loading";
import NoContent from "../common/NoContent";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import FiltersDrawer from "./users/FiltersDrawer";
import { useSelector } from "react-redux";
import UserCard from "../common/UserCard";
import { TEXT_SMALL } from "../../style";
import { AUTHORITIES } from "../../constants";
import Download from "./users/Dowload";

export default function Users() {
    const { requestAPI } = useAppContext();

    const { roles = [] } = useSelector((state) => state.stateTemplateConfig?.global);
    const { courses = [] } = useSelector((state) => state.stateTemplateConfig?.global);
    const { branches = [] } = useSelector((state) => state.stateTemplateConfig?.global);

    const [loading, setLoading] = useState();
    const [users, setUsers] = useState();
    const [error, setError] = useState();

    const [filters, setFilters] = useState();
    const [filtersDrawerVisibility, setFiltersDrawerVisibility] = useState();

    //limit page size to 7
    const limit = useMemo(() => 7, []);

    const [searchQuery, setSearchQuery] = useState({ limit, offSet: 0 });

    //Initially We need to fetch all the filters
    useEffect(() => {
        if (!filters?.length)
            requestAPI({
                requestMethod: "GET",
                requestPath: `filters/users`,
                setLoading: setLoading,
                onResponseReceieved: (filters, responseCode) => {
                    if (filters && responseCode === 200) {
                        return setFilters([
                            { title: "Roles", key: "roles", options: roles, type: "MULTI_SELECT" },
                            { title: "Enrolled Courses", key: "courses", options: courses, type: "MULTI_SELECT" },
                            { title: "Enrollment Branches", key: "branches", options: branches, type: "MULTI_SELECT" },

                            ...filters,
                        ]);
                    }
                    setError("Failed to Fetch Filters");
                },
            });
    }, [branches, courses, filters, requestAPI, roles]);

    //Fetch The Users
    useEffect(() => {
        requestAPI({
            requestMethod: "GET",
            requestPath: `users`,
            requestGetQuery: searchQuery,
            onRequestStart: setUsers,
            setLoading: setLoading,
            onResponseReceieved: (users, responseCode) => {
                if (users?.dataSet?.length && responseCode === 200) {
                    return setUsers(users);
                }
            },
        });
    }, [requestAPI, searchQuery]);

    const countAppliedFilters = useMemo(() => {
        const { search, limit, offSet, ...appliedFilters } = searchQuery;
        return Object.keys(appliedFilters).length;
    }, [searchQuery]);

    return (
        <HasRequiredAuthority requiredAuthority={AUTHORITIES.USE_PAGE_USERS}>
            <div className="flex flex-column h-full overflow-hidden">
                <HasRequiredAuthority requiredAuthority={AUTHORITIES.MANAGE_OTHER_USERS}>
                    <div className="flex align-items-center p-2 gap-1">
                        <SearchBar
                            className={"flex-1"}
                            countAppliedFilters={countAppliedFilters}
                            disable={loading}
                            setFiltersDrawerVisibility={setFiltersDrawerVisibility}
                            setSearchQuery={setSearchQuery}
                        />
                        {users?.recordsCount > 0 && <Download entity="users" searchQuery={searchQuery} />}
                    </div>
                </HasRequiredAuthority>

                <div className="flex-1 min-h-0  overflow-y-scroll p-2 bg-gray-100">
                    {loading ? (
                        <Loading />
                    ) : error || !users?.dataSet?.length ? (
                        <NoContent error="No Users Found" />
                    ) : (
                        users?.dataSet?.map((user) => <UserCard key={user?.id} {...user} />)
                    )}
                </div>

                {!loading && (
                    <Paginator
                        first={searchQuery?.offSet}
                        rows={limit}
                        totalRecords={users?.recordsCount}
                        onPageChange={(e) => {
                            setSearchQuery((prev) => ({ ...prev, offSet: e.first }));
                        }}
                        template={{
                            layout: "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink",
                            CurrentPageReport: (options) => (
                                <span className={`text-center w-8rem ${TEXT_SMALL}`}>
                                    {options.first} - {options.last} of {options.totalRecords}
                                </span>
                            ),
                        }}
                    />
                )}

                <FiltersDrawer
                    filtersDrawerVisibility={filtersDrawerVisibility}
                    setFiltersDrawerVisibility={setFiltersDrawerVisibility}
                    filters={filters}
                    setSearchQuery={setSearchQuery}
                />
            </div>
        </HasRequiredAuthority>
    );
}
